import { formatDate } from '../check-batch/format';
import type { PaymentMethod, RecordStatus } from './types';

export { formatDate, formatMoney, formatDateTime } from '../check-batch/format';

export const STATUS_LABEL: Record<RecordStatus, string> = {
  PendingApproval: 'Pending Approval',
  Approved: 'Approved',
  Paid: 'Paid',
  Failed: 'Failed',
  Voided: 'Voided',
};

export const METHOD_LABEL: Record<PaymentMethod, string> = {
  Check: 'Check',
  DirectDeposit: 'Direct Deposit',
  Electronic: 'Electronic (Zelle, etc.)',
  Cash: 'Cash',
  Other: 'Other',
};

export function statusLabel(status: string): string {
  return STATUS_LABEL[status as RecordStatus] ?? status;
}

export function methodLabel(method: string): string {
  return METHOD_LABEL[method as PaymentMethod] ?? method;
}

/** "Oct 1 - Oct 31" within a year, "Oct 1, 2025 - Jan 5, 2026" across years (Figma list shows the short form); "—" when the record has no period. */
export function servicePeriodText(start: string | null, end: string | null): string {
  if (!start || !end) return '—';
  return `${formatDate(start)} - ${formatDate(end)}`;
}

export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Whether this bundle may offer the record-changing actions (Mark as Paid, Void, Record Outside Payment). The server refuses them in Production too (501). */
export const recordWritesAvailableInBuild = (env: { PROD: boolean }): boolean => !env.PROD;
